import { render } from "./Survey.vue?vue&type=template&id=08abc2d7"
import script from "./Survey.vue?vue&type=script&lang=js"
export * from "./Survey.vue?vue&type=script&lang=js"

import "./Survey.vue?vue&type=style&index=0&id=08abc2d7&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__